import jwtDecode from 'jwt-decode';
import React, { useEffect,useState } from 'react'
import '../css/app.css';
import '../css/home.css';
import { getRequest } from '../request';
import getReq from '../interface/getRequestinterface';
import Loading from './loading';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';


const states = [
  { stat:'saleRegister', id: 0, title: "ثبت عملیات فروش" , unit:"واحد معاملات",position:'کارشناس مربوطه' },
  { stat:'supervisorCheck', id: 1, title: "بررسی درخواست توسط ناظر" , unit:"واحد نظارت و حقوقی",position:'کارشناس مربوطه' },
  { stat:'rialDocumentRegister', id: 2, title: "تایید دریافت وجه توسط مشتری و ثبت سند ریالی" , unit:"واحد ریالی",position:'کارشناس مربوطه' },
  { stat:'rialAccountingAdminCheck', id: 3, title: "بررسی توسط مدیر حسابداری ریالی" , unit:"واحد ریالی",position:"مدیر مربوطه" },
  { stat:'currencyDocumentRegister', id: 4, title: "ثبت سند ارزی" , unit:"واحد ارزی",position:'کارشناس مربوطه' },
  { stat:'assignToRefrenceAdmin', id: 5, title: "تخصیص به مسئول حوالجات" , unit:"واحد ارزی",position:"مدیر مربوطه" },
  { stat:'assignToRefrenceExpert', id: 6, title: "تخصیص کار به کارشناس حوالجات" , unit:"واحد حوالجات",position:'مدیر مربوطه'},
  { stat:'uploadFilledForms', id: 7, title: "دریافت مدارک از مشتری و بارگزاری" , unit:"واحد حوالجات",position:'کارشناس مربوطه' },
  { stat:'sendRequestToAgent', id: 8, title: "ارسال درخواست به کارگزار "  , unit:"واحد حوالجات",position:'کارشناس مربوطه'},
  { stat:'uploadRefrence', id: 9, title: "بارگزاری مدارک حواله دریافت شده از کارگزار" , unit:"واحد حوالجات",position:'کارشناس مربوطه' },
  { stat:'finalConfirm', id: 10, title: "ثبت نهایی/اصلاح سند ارزی" , unit:"واحد حوالجات",position:'کارشناس مربوطه' },
  { stat:'bankWorkFinishRegister', id: 11, title: "ثبت اختتامیه کار پس از تکمیل در سامانه بانک مرکزی" ,unit:"واحد حوالجات",position:'کارشناس مربوطه'  },
  { stat:'customerConfirmDateRegister', id: 12, title: "ثبت تاریخ تایید مشتری" ,  },
  { stat:'end', id: 13, title: "پایان" }
];

function Home() {
  const [fetchData, setFetchData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [decodedToken, setDecodedToken] = useState<any>({});
  const params = useParams();
  const requestCode = useSelector((state:any) => state.requestCode.code);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem('user');
  let decode:any = {};
  useEffect(() => {
    if (token) {
      decode = jwtDecode(token);
      console.log(decode)
      setDecodedToken(decode);
      if(decode.role  !== 'Admin' && decode.role !== 'Expert'){
        localStorage.setItem('requestType',decode.Type);
        }
      }
    if (decode.role  === 'Admin'|| decode.role  === 'Expert') {
      fetchAdminRequest();
    }else if(userId ){
      fetchDataFunction();
    }else{
      navigate('/login');
      toast.error('لطفا دوباره وارد سامانه شوید!'); 
    }
  }, []);
  
  const fetchDataFunction = async()=>{
    const data:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Report/state/${userId}`) as getReq;
    if(data && Object.keys(data).length){
      setFetchData(data.data);
      if(decodedToken.role !== 'Admin' && decodedToken.role !== 'Expert'){
        localStorage.setItem('customerName',data.data['customer'] );
      }
      setTimeout(() => {
        setIsLoading(true);
      }, 1000);
    }
  }
  const fetchAdminRequest=async()=>{
    const data:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Account/GetRequest/${params.requestId}`) as getReq;
    if(data && Object.keys(data).length){
      setFetchData(data.data);
      setTimeout(() => {
        setIsLoading(true);
      }, 1000);
    }
  }
  const handleClickShowForms=()=>{
    if(userId){
      if(decodedToken.Type === 'Nima'){
        navigate('/nimaForms');
      }else{
        navigate('/sanaForms');
      }
    }else{
      navigate('/expertCheckForms');
    }
  }
  const handleRouteToRequestHistory=()=>{
      navigate('/adminRequestHistory');
  }
  return (
    <div className='background'>
      {isLoading?
      <>
      <div className="color-guideMobile">
          <div>
            <div className="color" style={{backgroundColor: "orange"}}></div>
            <div className="guide">مراحل طی شده</div>
          </div>
          <div>
            <div className="color" style={{backgroundColor: "green"}}></div>
            <div className="guide">مرحله فعلی</div>
          </div>
          <div>
            <div className="color" style={{backgroundColor: "#748da6"}}></div>
            <div className="guide">مراحل باقیمانده</div>
          </div>
        </div>
      <div dir="rtl" className="mainDiv">
        {
          states.map((state,index)=>
          <div className="instructionList" key={index}>
            <div
              className={fetchData['state']===index?"currentstep":"step"}
            >
              {
                index !== 13?
                <div
                className={fetchData['state']>index?"passedPointer":
                fetchData['state']===index? "selectedPointer":"pointer"}
              >
                <b>
                  { index + 1 } 
                </b><span></span>
              </div>
                :null
              }
              
              {
                index ===13?
                <div
                  className={fetchData['state']===index?"currentEndPointer":"endPointer"}
                >
                  <span><b>{ index + 1 }</b></span>
                </div>
                :null
              }
              
              <div className='sectionTitle'>
                 { state.title } 
              </div>
              <div className='sectionDate'>
                 { fetchData[state.stat + "Date"] } 
                </div>
              <div>
                 {state.position } 
              </div>
              <div style={{fontWeight:'bold'}}>
                 { fetchData[state.stat + "Name"] }
              </div>
              <div>
                 {state.unit  }
                </div>
              <div >شماره داخلی:
                <span style={{fontWeight:'bold'}}> 
                 {fetchData[state.stat + "Tel"]}
                </span></div>
            </div>
          </div>
          )
        }
       
    </div>
        {fetchData['delayreason']?
          <div className="reason" >
            <div className="reason-title">دلیل تاخیر :</div>
            <div className="reason-value">
              { fetchData['delayreason'] }
            </div>
          </div>:null
        }
        <div className='highlightBtn'>
          
            <a  className="animated-button1" style={{marginLeft:'5px'}} onClick={handleClickShowForms} >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              برای نمایش فرم ها کلیک کنید
            </a>
            <a className="animated-button7" style={{marginRight:'5px'}} onClick={handleRouteToRequestHistory} >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              نمایش تاریخچه درخواست ها
            </a>
          
        </div>
        <div className='infoSection'>
          <div className="info" >
            
            <div className="section-title">جزئیات درخواست</div>
            <div className="section">
                <div className="title">شماره درخواست :</div>
                <div className="value">{ fetchData['requestCode'] }</div>
                <div className="title">مبلغ :</div>
                <div className="value">{ fetchData['amount']?.toLocaleString() }</div>
                <div className="title">ارز :</div>
                <div className="value">{ fetchData['currency'] }</div>
                <div className="title">مشتری :</div>
                <div className="value">{ fetchData['customer'] }</div>
                <div className="title">کشور مقصد :</div>
                <div className="value">{ fetchData['destinationCountry'] }</div>
                <div className="title">تاریخ انجام حواله :</div>
                <div className="value">{ fetchData['swiftDate'] }</div>
            </div>
          </div>
        </div>
        
        <div className="color-guide">
          <div>
            <div className="color" style={{backgroundColor: "orange"}}></div>
            <div className="guide">مراحل طی شده</div>
          </div>
          <div>
            <div className="color" style={{backgroundColor: "green"}}></div>
            <div className="guide">مرحله فعلی</div>
          </div>
          <div>
            <div className="color" style={{backgroundColor: "#748da6"}}></div>
            <div className="guide">مراحل باقیمانده</div>
          </div>
        </div>
      </>
      :
      <div style={{width:'100vw',height:'calc( 100vh - 64px)',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Loading type="cylon" color="#000"/>
        </div>}
      
    </div>
  )
}

export default Home